import { type GithubActionsApi } from '@backstage-community/plugin-github-actions';
import { type Workflow, type WorkflowRun } from './types';
import { createApiRef } from '@backstage/frontend-plugin-api';

export const githubActionsHealthApiRef = createApiRef<GithubActionsHealthApi>({
    id: 'plugin.githubactionshealth.service'
})

export interface GithubActionsHealthApi extends GithubActionsApi {
    listWorkflowsForRepository: (options: {hostname?: string, owner: string, repo: string}) => Promise<Workflow[]>;
    listWorkflowRunsForWorkflowId: (options: {hostname?: string, owner: string, repo: string, workflowId: number}) => Promise<WorkflowRun[]>;
};
